import initProductCarousel from '../../pages/product-page/productCarousel';
import Popup from '../../components/base/Popup';

/**
 * Установить кол-во товара (в хедере)
 *
 * @param {number} count  кол-во товара
 */
function setBasketCount(count) {
    $('.js-header-basket-count').html(count);
}

/**
 * @param {jQuery|string} $wrapper враппер, в котором находится список вариантов
 * @return {*|jQuery|string|undefined} Id выбранного варианта
 */
function getCurrentVariant($wrapper) {
    return $('.js-selected-variant input:checked', $wrapper).val();
}

/**
 * @param {jQuery|string} $wrapper враппер, в котором находится список вариантов
 * @return {*|jQuery|string|undefined} Id склада оутлет выбранного варианта
 */
function getCurrentOutlet($wrapper) {
    return $('.product-outlet input:checked', $wrapper).val();
}

/**
 * @param  {jQuery|string} $wrapper враппер, в котором находится список вариантов
 * @return {*|jQuery|string|undefined} кол-во товара
 */
function getProductCount($wrapper) {
    return $('.js-product-count input', $wrapper).val();
}

/**
 * @param {jQuery|string}  $wrapper враппер, в котором находится списко вариатов
 */
function initChangeVariantsHandler($wrapper) {
    const $variants = $('.js-selected-variant input');
    const $outlet = $wrapper.find('.product-outlet input');
    const $btnToCart = $wrapper.find('.js-product-add-to-cart');
    $variants.on('change', function() {
        const info = $(this).data('info');

        const $carouselWrapper = $('.js-product-carousel-wrapper');
        const $currentCarouselWrapper = $carouselWrapper.filter(`[data-variant-id=${info.variantId}]`);
        if ($currentCarouselWrapper.length) {
            $carouselWrapper.hide();
            $currentCarouselWrapper.show();
            initProductCarousel($currentCarouselWrapper);
        }

        const $quickViewPic = $('.js-product-quick-view-pic');
        const $currentQuickViewPic = $quickViewPic.filter(`[data-variant-id=${info.variantId}]`);
        if ($currentQuickViewPic.length) {
            $quickViewPic.hide();
            $currentQuickViewPic.show();
        }

        $wrapper.find('.js-price').html(info.price);
        $wrapper.find('.js-old-price').html(info.oldPrice);
        $wrapper.find('.js-percent').html(info.percent);
        $wrapper
            .find('.js-product-add-to-cart')
            .data('variant-id', info.variantId)
            .attr('data-variant-id', info.variantId);

        if (info.oldPrice) {
            $wrapper.find('.js-with-old-price').show();
        } else {
            $wrapper.find('.js-with-old-price').hide();
        }

        if (info.canBuy) {
            $wrapper.find('.js-can-buy-button').show();
            $wrapper.find('.js-cant-buy-button').hide();
        } else {
            $wrapper.find('.js-can-buy-button').hide();
            $wrapper.find('.js-cant-buy-button').show();
        }

        if (info.outlet) {
            $outlet.prop('checked', false);
            // eslint-disable-next-line guard-for-in,no-restricted-syntax
            for (const store in info.outlet.STORES) {
                const item = info.outlet.STORES[store];
                const $priceBox = $wrapper.find(`[for="outlet-store-${store}"]`);
                if (item.PRICE === 0) {
                    $priceBox.hide();
                } else {
                    $priceBox.find('.js-outlet-price').html(item.PRICE);
                    $priceBox.find('.js-outlet-status').html(item.STATUS);
                    if (item.SELECTED) {
                        $outlet.filter(`[value="${store}"]`).prop('checked', true);
                        $wrapper.find('.js-product-add-to-cart').data('outlet', store);
                    }
                    $priceBox.show();
                }
            }
            if (info.outlet.COUNT < 2) {
                $wrapper.find('.js-outlet-title').hide();
            } else {
                $wrapper.find('.js-outlet-title').show();
            }
        }
        if (info.basket) {
            $btnToCart
                .attr('disabled', true)
                .find('span')
                .html($btnToCart.data('msg-in-basket'));
        } else {
            $btnToCart
                .attr('disabled', false)
                .find('span')
                .html($btnToCart.data('msg-out-basket'));
        }
    });

    if ($outlet.length) {
        $outlet.on('change', function() {
            const info = $variants.filter(':checked').data('info');
            const store = $outlet.filter(':checked').val();
            $btnToCart.data('outlet', store);
            if (info.outlet.STORES[store].BASKET) {
                $btnToCart
                    .attr('disabled', true)
                    .find('span')
                    .html($btnToCart.data('msg-in-basket'));
            } else {
                $btnToCart
                    .attr('disabled', false)
                    .find('span')
                    .html($btnToCart.data('msg-out-basket'));
            }
        });
    }
}

export { setBasketCount, getCurrentVariant, getCurrentOutlet, getProductCount, initChangeVariantsHandler };

export default () => {
    /**
     * Кнопка добавления в корзину
     */
    $(document).on('click', '.js-product-add-to-cart', function(evt) {
        var variantId = $(this).data('variant-id') || getCurrentVariant();
        var count = getProductCount() || 1;
        var outlet = $(this).data('outlet');
        var data = {};

        if ($(this).data('has-outlet') === 'N') {
            const popupInstance = new Popup($('#popup-outlet_add'));
            popupInstance.init();
            popupInstance.open();
            $(this).data('has-outlet', 'Y');
        }

        if (outlet) {
            data.outlet = outlet;
        }

        evt.preventDefault();
        const allBtn = $(`.js-product-add-to-cart[data-variant-id=${variantId}]`);
        allBtn.each((_, btn) => {
            const $btn = $(btn);
            $btn.prop('disabled', true);
            const msg = $btn.data('msg-in-basket');
            const btnSpan = $btn.find('span');
            if (btnSpan.length) {
                btnSpan.html(msg);
            } else {
                $btn.html(msg);
            }
        });

        $.post(`/api/internal/basket/add/${variantId}/${count}`, data, function(result) {
            setBasketCount(result.data.total.itemCount);
            const info = $('.js-selected-variant input:checked').data('info');
            if (info.outlet) {
                info.outlet.STORES[outlet].BASKET = true;
                if (info.store == outlet) {
                    info.basket = true;
                }
            } else {
                info.basket = true;
            }
        });
    });

    /**
     * Кнопка добавления в избранное
     */
    $(document).on('click', '.js-product-toggle-wishlist', function() {
        var variantId = $(this).data('variant-id');
        var isShort = $(this).data('short') || 0;
        $.post(`/api/internal/product/toggle-wishlist/${variantId}/${isShort}`, result => {
            $(this)
                .find('span')
                .html(result.newButtonText);
        });
    });

    /**
     * Кнопка удаления из избранного
     */
    $(document).on('click', '.js-product-delete-from-wishlist', function() {
        var variantId = $(this).data('variant-id');
        $.post(`/api/internal/product/delete-from-wishlist/${variantId}`, () => {
            $(this)
                .closest('tr')
                .remove();
        });
    });

    /**
     * Отмена заказа
     */
    $(document).on('click', '.js-order-cancel', function() {
        if (window.confirm('Удалить заказ?')) {
            // eslint-disable-next-line vars-on-top
            var orderId = $(this).data('order-id');
            $.post(`/api/internal/order/cancel/${orderId}`, result => {
                if (result.redirect) {
                    window.location = result.redirect;
                }
            });
        }
    });
};
